import { FC } from "react"
import Box from "@mui/material/Box"
import { StyledChip } from "./styles"
import { Icon, IconColor } from "@/components/shared/Icon"

interface ChipsProps {
   items: { label: string; value: string; disabled?: boolean }[]
   onDelete: (valueToDelete: string) => void
}

const Chips: FC<ChipsProps> = ({ items, onDelete }) => {
   return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
         {items.map((opt) => (
            <StyledChip
               key={opt.value}
               label={opt.label}
               {...(!opt.disabled && {
                  onMouseDown: (e) => e.stopPropagation(),
                  onClick: () => onDelete(opt.value),
                  onDelete: (e) => {
                     e.stopPropagation()
                     onDelete(opt.value)
                  },
                  deleteIcon: (
                     <Icon
                        name="cross"
                        size="8"
                        color={IconColor.HONOLULU_BLUE}
                     />
                  ),
               })}
            />
         ))}
      </Box>
   )
}

export default Chips
